var Marker, m;

m = require('mithril');

Marker = {
  view: function(ctrl, args) {
    return m('.marker', [
      m('.marker__info', [args.marker.name, m('.marker__weight', "" + args.marker.weight)]), m('input[type=button][value="Remove"]', {
        onclick: function() {
          return args.onRemove(args.marker);
        }
      })
    ]);
  }
};

module.exports = {
  view: function(ctrl, args) {
    var marker;
    return m('.markers', [
      (function() {
        var i, len, ref, results;
        ref = args.markers();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          marker = ref[i];
          results.push(m(Marker, {
            marker: marker,
            onRemove: args.onRemove
          }));
        }
        return results;
      })()
    ]);
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3VpL2NvbXBvbmVudHMvTWFya2Vycy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvd29yay9zcmMvdWkvY29tcG9uZW50cy9NYXJrZXJzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixNQUFBLEdBQVM7RUFDUixJQUFBLEVBQU0sU0FBQyxJQUFELEVBQU8sSUFBUDtXQUNMLENBQUEsQ0FBRSxTQUFGLEVBQWE7TUFDWixDQUFBLENBQUUsZUFBRixFQUFtQixDQUNsQixJQUFJLENBQUMsTUFBTSxDQUFDLElBRE0sRUFFbEIsQ0FBQSxDQUFFLGlCQUFGLEVBQXFCLEVBQUEsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLE1BQXBDLENBRmtCLENBQW5CLENBRFksRUFLWixDQUFBLENBQUUsb0NBQUYsRUFBd0M7UUFBQyxPQUFBLEVBQVMsU0FBQTtpQkFBTSxJQUFJLENBQUMsUUFBTCxDQUFjLElBQUksQ0FBQyxNQUFuQjtRQUFOLENBQVY7T0FBeEMsQ0FMWTtLQUFiO0VBREssQ0FERTs7O0FBV1QsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO1dBQUEsQ0FBQSxDQUFFLFVBQUYsRUFBYzs7O0FBQ2I7QUFBQTthQUFBLHFDQUFBOzt1QkFBQSxDQUFBLENBQUUsTUFBRixFQUFVO1lBQUMsTUFBQSxFQUFRLE1BQVQ7WUFBaUIsUUFBQSxFQUFVLElBQUksQ0FBQyxRQUFoQztXQUFWO0FBQUE7O1VBRGE7S0FBZDtFQURLLENBRFUifQ==
